// Annuler sécurisé T1 (6b.2) — overlay MAISON de confirmation (pattern FIN DE
// SERVICE) : récap « N pizza(s) » pluralisé (N = Σ qty, jamais le nombre de lignes) + client
// ou « Sans client ». RETOUR = défaut (gros, ardoise) · ANNULER LA COMMANDE =
// destructive. Purement présentatif : zéro écriture ici, la transition reste au
// gate (INV-B). Zéro animation.
import { pluriel } from '@/lib/pluriel';

interface Props {
  nbPizzas: number;
  clientNom?: string | undefined;
  onRetour: () => void;
  onConfirmer: () => void;
}

export function AnnulerCommandeOverlay({
  nbPizzas,
  clientNom,
  onRetour,
  onConfirmer,
}: Props) {
  return (
    <div
      data-testid="annuler-confirm"
      className="fixed inset-0 z-50 flex flex-col justify-center gap-6 border-4 border-ardoise bg-creme p-8"
    >
      <p className="font-cormorant text-4xl italic text-ardoise">Annuler la commande ?</p>
      <p className="font-jost text-2xl text-ardoise">
        <span className="font-mono" data-testid="annuler-count">
          {nbPizzas}
        </span>{' '}
        {pluriel(nbPizzas, 'pizza')} · {clientNom}
      </p>
      <div className="flex gap-4">
        <button
          type="button"
          onClick={onRetour}
          className="min-h-[120px] flex-[2] rounded-lg bg-ardoise font-jost text-2xl text-creme"
        >
          RETOUR
        </button>
        <button
          type="button"
          onClick={onConfirmer}
          className="min-h-[120px] flex-1 rounded-lg bg-destructive font-jost text-2xl text-destructive-foreground"
        >
          ANNULER LA COMMANDE
        </button>
      </div>
    </div>
  );
}
